import React, {useEffect, useId, useRef, useState} from 'react';
import {getCheckoutAvailability} from '../../api/checkoutAvailability';
import './CheckoutAvailabilityNotice.css';

export default function CheckoutAvailabilityNotice({onChange}) {
    const titleId = useId();
    const [availability, setAvailability] = useState(null);
    const callback = useRef(onChange);
    callback.current = onChange;
    useEffect(() => {
        let active = true;
        let busy = false;
        const refresh = async () => {
            if (busy || document.visibilityState === 'hidden') return;
            busy = true;
            let next;
            try { next = await getCheckoutAvailability(); }
            catch { next = {checkout_enabled:false, message:'Checkout is temporarily unavailable. Please try again later.'}; }
            finally { busy = false; }
            if (active) { setAvailability(next); callback.current?.(next); }
        };
        void refresh();
        const timer = setInterval(refresh, 30000);
        const visible = () => { if (document.visibilityState === 'visible') void refresh(); };
        window.addEventListener('focus', refresh);
        document.addEventListener('visibilitychange', visible);
        return () => {active = false; clearInterval(timer); window.removeEventListener('focus', refresh); document.removeEventListener('visibilitychange', visible);};
    }, []);
    if (!availability || availability.checkout_enabled) return null;
    return <div className="checkout-availability-notice" role="alert" aria-labelledby={titleId}>
        <span className="checkout-availability-notice__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" focusable="false">
                <path d="M10.3 4.1 2.5 17.5a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 4.1a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4m0 3h.01"/>
            </svg>
        </span>
        <div className="checkout-availability-notice__content">
            <span className="checkout-availability-notice__eyebrow">Checkout update</span>
            <h2 className="checkout-availability-notice__title" id={titleId}>Checkout unavailable</h2>
            <p className="checkout-availability-notice__message">{availability.message}</p>
        </div>
        {availability.live_store_url === 'https://naturewaymart.com' && <a className="checkout-availability-notice__action" href="https://naturewaymart.com">Shop at naturewaymart.com<span aria-hidden="true">→</span></a>}
    </div>;
}
